import Vue from 'vue'
// import VueFilter from 'vue-filter'
import moment from 'moment'
import formatUtils from '@/utils/format'
import store from '@/store/index'
import { getUserRole, shouldMaskData } from '@/utils/roleHelper'

// Vue.use(VueFilter)

// 🔒 Armazenar referência do store globalmente para acesso nos filtros
Vue.prototype.$store = store

// 🔒 Disponibilizar store globalmente para filtros
if (typeof window !== 'undefined') {
  window.store = store
}

Vue.filter('uppercase', function(value, mask) {
  if (value) {
    return value.toUpperCase()
  } else {
    return '---'
  }
})

Vue.filter('capitalize', function(value, mask) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('firstName', function(value, mask) {
  if (!value) return ''
  let names = value.toString().split(' ')
  if (!names.length) return ''
  return names[0]
})

Vue.filter('formatDateDay', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YY')
    } else {
      return moment(value).format('DD')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateMonth', function(value, mask) {
  const lang = window.$i18n && window.$i18n.locale
  if (value) {
    if (mask) {
      return moment(String(value), mask).locale(lang).format('DD/MM/YY')
    } else {
      return moment(value).locale(lang).format('MMM')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateYear', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YY')
    } else {
      return moment(value).format('YYYY')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDate', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YY')
    } else {
      return moment(value).format('DD/MM/YY')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateTimeAgo', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).fromNow()
    } else {
      return moment(value).fromNow()
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateExtend', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YYYY')
    } else {
      return moment(value).format('DD/MM/YYYY')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateShort', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM')
    } else {
      return moment(value).format('DD/MM')
    }
  } else {
    return '---'
  }
})

Vue.filter('formatDateTime', function(value, mask) {
  if (value) {
    if (mask) {
      return moment(String(value), mask).format('DD/MM/YY HH:mm')
    } else {
      return moment(value).format('DD/MM/YY HH:mm')
    }
  } else {
    return '---'
  }
})

Vue.filter('phone', function(value) {
  if (!value) return '---'
  const clean = value.toString().replace(/[^0-9]/g, '')
  if (clean.length === 11) {
    return `(${clean.slice(0, 2)}) ${clean.slice(2, 7)}-${clean.slice(7)}`
  }
  if (clean.length === 10) {
    return `(${clean.slice(0, 2)}) ${clean.slice(2, 6)}-${clean.slice(6)}`
  }
  return value
})

Vue.filter('risk', function(value) {
  if (value) {
    return value.replace('in', 'em')
  } else {
    return '---'
  }
})

/**
 * 🔒 FILTRO CPF - Com ofuscação automática baseada em role
 *
 * Se usuário for 'attendant', ofusca automaticamente
 * Outros roles veem CPF completo formatado
 */
Vue.filter('cpf', function(value, forceMask = false) {
  if (!value) return '---'

  try {
    // 🔒 Usar helper para obter role do usuário
    const shouldMask = shouldMaskData(forceMask)

    // Remover formatação existente
    const cleanValue = value.toString().replace(/[^0-9]/g, '')

    if (cleanValue.length !== 11) {
      return value
    }

    if (shouldMask) {
      // Mostrar apenas últimos 2 dígitos
      const lastDigits = cleanValue.substr(9, 2)
      return `XXX.XXX.XXX-${lastDigits}`
    } else {
      // Mostrar CPF completo formatado
      return `${cleanValue.substr(0, 3)}.${cleanValue.substr(3, 3)}.${cleanValue.substr(6, 3)}-${cleanValue.substr(9, 2)}`
    }
  } catch (error) {
    // Em caso de erro, retornar formatado normalmente (fail-safe)
    console.warn('⚠️ Erro ao processar filtro CPF:', error)
    const cleanValue = value.toString().replace(/[^0-9]/g, '')
    if (cleanValue.length === 11) {
      return `${cleanValue.substr(0, 3)}.${cleanValue.substr(3, 3)}.${cleanValue.substr(6, 3)}-${cleanValue.substr(9, 2)}`
    }
    return value
  }
})

/**
 * 🔒 FILTRO CPF MASK - Força ofuscação (mantido para compatibilidade)
 */
Vue.filter('cpfMask', function(value) {
  return Vue.filter('cpf')(value, true) // Forçar ofuscação
})

/**
 * 🔒 FILTRO CNPJ - Com ofuscação automática baseada em role
 *
 * Se usuário for 'attendant', ofusca automaticamente
 * Outros roles veem CNPJ completo formatado
 */
Vue.filter('cnpj', function(value, forceMask = false) {
  if (!value) return '---'

  try {
    // 🔒 Usar helper para obter role do usuário
    const shouldMask = shouldMaskData(forceMask)

    // Remover formatação existente
    const cleanValue = value.toString().replace(/[^0-9]/g, '')

    if (cleanValue.length !== 14) {
      return value
    }

    if (shouldMask) {
      // Mostrar apenas últimos 2 dígitos
      const lastDigits = cleanValue.substr(12, 2)
      return `XX.XXX.XXX/XXXX-${lastDigits}`
    } else {
      // Mostrar CNPJ completo formatado
      return `${cleanValue.substr(0, 2)}.${cleanValue.substr(2, 3)}.${cleanValue.substr(5, 3)}/${cleanValue.substr(8, 4)}-${cleanValue.substr(12, 2)}`
    }
  } catch (error) {
    console.warn('⚠️ Erro ao processar filtro CNPJ:', error)
    const cleanValue = value.toString().replace(/[^0-9]/g, '')
    if (cleanValue.length === 14) {
      return `${cleanValue.substr(0, 2)}.${cleanValue.substr(2, 3)}.${cleanValue.substr(5, 3)}/${cleanValue.substr(8, 4)}-${cleanValue.substr(12, 2)}`
    }
    return value
  }
})

Vue.filter('money', function(value) {
  try {
    // ✅ CORREÇÃO: Verificação mais robusta e fallback seguro
    if (value !== null && value !== undefined && !isNaN(parseFloat(value))) {
      const numValue = parseFloat(value)
      if (formatUtils && formatUtils.money) {
        return formatUtils.money(numValue)
      } else {
        // Fallback usando Intl.NumberFormat se formatUtils falhar
        return new Intl.NumberFormat('pt-BR', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(numValue)
      }
    } else {
      return '0,00'
    }
  } catch (error) {
    console.warn('Erro no filtro money:', error)
    return '0,00'
  }
})

Vue.filter('moneyWithoutDecimals', function(value) {
  if (value) {
    return formatUtils.money(value, 0)
  } else {
    return 0
  }
})

Vue.filter('number', function(value) {
  if (value) {
    return `${value}`
  } else {
    return '-'
  }
})

Vue.filter('decimal', function(value) {
  if (isNaN(value) || value === '') {
    return value
  } else {
    const val = parseFloat(value)
    return val.toFixed(2)
  }
})

Vue.filter('dynamicFilter', function(value, name, ...args) {
  return Vue.filter(name)(value, ...args)
})
